import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const EXTRA_RESPONSIBILITY = FORM_FIELDS.EMPLOYEE.EXTRA_RESPONSIBILITY;

const {
  WING_DESK_IO_E0,
  DESIGNATION,
  POSITION,
  GRADE,
  TYPE,
  START_DATE,
  // END_DATE,
  PASSWORD,
} = EXTRA_RESPONSIBILITY;

export const extraResponsibilityValidation = yup.object().shape({
  [WING_DESK_IO_E0]: yup
    .number()
    .required("Wing/Desk/I.O/E.O is required")
    .typeError("Wing/Desk/I.O/E.O is required"),
  [DESIGNATION]: yup
    .number()
    .required("Designation is required")
    .typeError("Designation is required"),
  [GRADE]: yup
    .number()
    .required("Grade is required")
    .typeError("Grade is required"),
  //make it required when showAllDesignations is false
  [POSITION]: yup
    .number()
    .nullable()
    .typeError("Position is required")
    .when("showAllDesignations", (values: any[], schema: any) => {
      if (!values[0]) {
        return schema.required("Position is required");
      }
      return schema;
    }),
  [TYPE]: yup.string().required("Type is required"),
  [START_DATE]: yup.string().required("Start Date is required"),
  // [END_DATE]: yup.string().required("End Date is required"),
});

export const acceptExtraResponsibilityValidation = yup.object().shape({
  [PASSWORD]: yup.string().required("Password is required"),
});

export type ExtraResponsibilityFormDataType = yup.InferType<
  typeof extraResponsibilityValidation
>;

export type AcceptExtraResponsibilityFormDataType = yup.InferType<
  typeof acceptExtraResponsibilityValidation
>;
